// @flow
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { MdSearch, MdClose } from 'react-icons/lib/md';

import Popup from '../Popup';
import Geosearch from '../Geosearch';
import Footer from '../CityFooter';
import PopupCloseButton from '../PopupCloseButton';
import * as closeableActions from '../../actions/closeable';

import styles from './searchAddressPopup.css';


type SearchAddressPopupPropTypes = {
  id?: string,
  label?: string,
  placeholder?: string,
  onPlaceSelected?: Function,
  searchOptions?: Object
};

const SearchAddressPopup = ({
  id,
  label,
  placeholder = 'ie. McDonald\'s zona 10',
  onPlaceSelected,
  searchOptions = {},
}: SearchAddressPopupPropTypes) => (
  <Popup
    id={id}
    theme="white"
    closeOnClickOutside={false}>
    <Fragment>
      <div className={`${styles.header} ${styles.toRight}`}>
        <PopupCloseButton
          size="large"
          Icon={MdClose}
          tint="mediumGray"
          clearMargins
          isTransparent
          isOutlined
        />
      </div>
      <div className={styles.searchAddressPopup}>
        {
            label
              && (
                <div className={styles.label}>
                  { label }
                </div>
              )
          }
        {
          <Geosearch
            Icon={MdSearch}
            className={styles.searchInput}
            iconPosition="right"
            onPlaceSelected={onPlaceSelected}
            placeholder={placeholder}
            size="large"
            elevation={2}
            options={searchOptions}
            autoFocus
          />
          }
      </div>
      <Footer />
    </Fragment>
  </Popup>
);


export default connect(
  undefined,
  (dispatch, { id, onPlaceSelected }) => ({
    onPlaceSelected(place, autocomplete) {
      dispatch(closeableActions.close(id));
      if (onPlaceSelected) { onPlaceSelected(place, autocomplete); }
    },
  }),
)(SearchAddressPopup);



// WEBPACK FOOTER //
// ./src/scripts/components/SearchAddressPopup/index.jsx